// Đầu trang của khu Quản trị NPP: tiêu đề + hành động, cùng nếp PageHeader của web (điện thoại: tiêu đề chỉ
// cho trình đọc màn hình — thanh trên đã ghi). Không có lời dẫn / chữ giải thích (hướng dẫn nằm ở tài liệu).

import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function PageIntro({
  title,
  actions,
  className,
}: {
  title: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('space-y-3', className)}>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
        <div className="flex min-w-0 items-center gap-2">
          <h1 className="min-w-0 mobile:sr-only">{title}</h1>
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2 mobile:w-full mobile:[&>*]:flex-1">{actions}</div>}
      </div>
    </div>
  )
}

export type PillTone = 'ok' | 'warn' | 'danger' | 'info' | 'neutral' | 'accent' | 'violet' | 'orange' | 'yellow' | 'red'

const PILL: Record<PillTone, string> = {
  ok: 'bg-ok/12 text-ok',
  warn: 'bg-warn/12 text-warn',
  danger: 'bg-danger/12 text-danger',
  info: 'bg-info/12 text-info',
  neutral: 'bg-paperSoft text-inkSoft',
  accent: 'bg-accent/10 text-accent',
  violet: 'tone-violet bg-toneBg text-toneFg',
  orange: 'tone-orange bg-toneBg text-toneFg',
  yellow: 'tone-yellow bg-toneBg text-toneFg',
  red: 'tone-red bg-toneBg text-toneFg',
}

/** Nhãn nhỏ dạng viên thuốc — trạng thái, loại đơn vị. Không xuống dòng. */
export function Pill({ tone = 'neutral', dot = false, children, className }: { tone?: PillTone; dot?: boolean; children: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium', PILL[tone], className)}>
      {dot && <span className="size-1.5 rounded-full bg-current" aria-hidden />}
      {children}
    </span>
  )
}
